import { preloadImage } from '@mail/3promo/utils';
import promoAsideModalImage from 'img/aside-promo-modal/flexible-quota-promo.gif';
import promoAsideModalImageDark from 'img/aside-promo-modal/flexible-quota-promo-dark.gif';
import promoModalImageDark from 'img/flexibleQuotaPromo/flexibleQuotaPromoModalDarkV2.gif';
import promoModalImage from 'img/flexibleQuotaPromo/flexibleQuotaPromoModalLightV2.gif';
import { IS_AUTO_TEST_HIDE } from 'reactApp/appHelpers/configHelpers';
import { emitAnalyticEvent } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import {
    flexibleQuotaAsidePromo,
    flexibleQuotaAsidePromoSettings,
    flexibleQuotaTurnAsidePromo,
} from 'reactApp/appHelpers/featuresHelpers/features/flexibleQuotaTariffs';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { storeHelper } from 'reactApp/modules/promo/promo.helpers';
import { addPromoToShowQueue, promoShown, removePromo } from 'reactApp/modules/promo/promo.module';
import { PromoSelectors } from 'reactApp/modules/promo/promo.selectors';
import { EPromoType } from 'reactApp/modules/promo/promo.types';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { isCurrentDarkTheme } from 'reactApp/modules/theme/theme.selectors';
import { isCloudOrMailOrApiOverQuota } from 'reactApp/modules/userQuota/overquota.helpers';
import { loadUserQuotaSuccess } from 'reactApp/modules/userQuota/userQuota.module';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';
import { store } from 'reactApp/store';
import { openAsidePromoModal } from 'reactApp/ui/AsidePromoModal/AsidePromoModal.helpers';
import { openFlexibleQuotaModal } from 'reactApp/ui/FlexibleQuotaModal/FlexibleQuotaModal.helpers';
import { renderFlexibleQuotaPromoModal } from 'reactApp/ui/FlexibleQuotaPromoModal/FlexibleQuotaPromoModal.helper';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';
import { getDays } from 'reactApp/utils/Period';
import { put } from 'redux-saga/effects';
import { select, take } from 'typed-redux-saga';

const PRELOAD_TIMEOUT = 3 * 1000;
const FLEXIBLE_QUOTA_PROMO_ID = 'flexible-quota-modal-v2';
const FLEXIBLE_QUOTA_PROMO_HITS = 'flexible-quota-hits-v2';
export const FLEXIBLE_QUOTA_SUCCESS_BUY = 'flexible-quota-success-buy-v2';

export function* initFlexibleQuotaPromo() {
    const storage = yield* select(getCurrentStorage);
    const { isHome } = getStorage(storage);
    const isMobile = yield* select(EnvironmentSelectors.isMobile);

    const { isLoaded: isUserQuotaLoaded } = yield* select(UserQuotaSelectors.getLoadingState);
    if (!isUserQuotaLoaded) {
        yield take(loadUserQuotaSuccess);
    }

    if (!flexibleQuotaAsidePromo) {
        return;
    }

    const isOverQuota = yield* select(isCloudOrMailOrApiOverQuota);

    // показываем на /home и просмотрщике
    // скрываем на автотестых и таче
    // скрываем для оверквотера
    if (!isHome || isMobile || IS_AUTO_TEST_HIDE || isOverQuota) {
        return;
    }

    // Если купил тариф (любой), больше не показывать в течение 3 месяцев
    const withSuccessPayment = storeHelper.getValue(FLEXIBLE_QUOTA_SUCCESS_BUY);
    const successPeriodPassed =
        storeHelper.getValue(FLEXIBLE_QUOTA_PROMO_ID) &&
        storeHelper.isPassed(FLEXIBLE_QUOTA_PROMO_ID, { daysCount: getDays(flexibleQuotaAsidePromoSettings.successTimePeriod) });

    if (withSuccessPayment && !successPeriodPassed) {
        return;
    }

    if (successPeriodPassed) {
        storeHelper.clearStore(FLEXIBLE_QUOTA_SUCCESS_BUY);
    }

    // Показать 2 раза с перерывом 7 дней
    // Далее показывать 1 раз в месяц
    const promoShownCount = storeHelper.getValue(FLEXIBLE_QUOTA_PROMO_HITS) || 0;
    const daysCount = getDays(
        promoShownCount < flexibleQuotaAsidePromoSettings.firstTimeHits
            ? flexibleQuotaAsidePromoSettings.firstTimePeriod
            : flexibleQuotaAsidePromoSettings.restTimePeriod
    );
    const periodPassed = storeHelper.getValue(FLEXIBLE_QUOTA_PROMO_ID) && storeHelper.isPassed(FLEXIBLE_QUOTA_PROMO_ID, { daysCount });

    if (periodPassed) {
        storeHelper.clearStore(FLEXIBLE_QUOTA_PROMO_ID);
    }

    if (!storeHelper.getValue(FLEXIBLE_QUOTA_PROMO_ID)) {
        yield put(
            addPromoToShowQueue({
                type: EPromoType.flexibleQuotaPromo,
                promoId: FLEXIBLE_QUOTA_PROMO_ID,
                onClick: () => {
                    openFlexibleQuotaModal({ source: 'flexible_subscription' });
                    sendPaymentGa({
                        action: 'click',
                        eventCategory: ECategoryGa.balloon,
                        name: 'mnz_flexible_subscription',
                    });
                    emitAnalyticEvent(AnalyticEventNames.FLEXIBLE_QUOTA_PROMO_CLICK);
                    store.dispatch(removePromo(EPromoType.flexibleQuotaPromo));
                },
                onShow: () => {
                    sendPaymentGa({
                        action: 'show',
                        eventCategory: ECategoryGa.balloon,
                        name: 'mnz_flexible_subscription',
                    });

                    emitAnalyticEvent(AnalyticEventNames.FLEXIBLE_QUOTA_PROMO_SHOW);
                    storeHelper.markAsShown(FLEXIBLE_QUOTA_PROMO_ID);
                    storeHelper.setValue(FLEXIBLE_QUOTA_PROMO_HITS, promoShownCount + 1);
                    store.dispatch(promoShown(EPromoType.flexibleQuotaPromo));
                },
                onClose: () => {
                    emitAnalyticEvent(AnalyticEventNames.FLEXIBLE_QUOTA_PROMO_CLOSE);
                    store.dispatch(removePromo(EPromoType.flexibleQuotaPromo));
                },
            })
        );
    }
}

export function* showFlexibleQuotaPromo() {
    const isDarkTheme = yield* select(isCurrentDarkTheme);
    const promo = yield* select(PromoSelectors.getPromo(EPromoType.flexibleQuotaPromo));

    if (!promo) {
        return;
    }

    const { onShow, onClick, onClose } = promo;

    if (flexibleQuotaTurnAsidePromo) {
        const imageUrl = isDarkTheme ? promoAsideModalImageDark : promoAsideModalImage;
        yield preloadImage({ src: imageUrl, timeout: PRELOAD_TIMEOUT });
        yield openAsidePromoModal({
            title: 'Добавьте столько\u00A0ГБ, сколько правда нужно',
            text: 'Вариант, когда не хватает совсем чуть-чуть, а переплачивать не\u00A0хочется',
            buttonText: 'Добавить',
            imageUrl,
            showAboveViewer: true,
            onShow,
            onClick,
            onClose,
        });
    } else {
        const imageUrl = isDarkTheme ? promoModalImageDark : promoModalImage;
        yield preloadImage({ src: imageUrl, timeout: PRELOAD_TIMEOUT });
        yield renderFlexibleQuotaPromoModal({
            title: 'Добавьте в\u00A0Облако столько места, сколько нужно',
            text: 'Вариант, когда совсем чуть-чуть не\u00A0хватает места для файлов, а\u00A0переплачивать не\u00A0хочется. С\u00A0Mail Space теперь можно и\u00A0так',
            buttonText: 'Добавить',
            imageUrl,
            onShow,
            onClick,
            onClose,
        });
    }
}
